/**
 * Các keys tương ứng với các chức năng trong context menu của grid-editor
 * @author nvthinh 7.11.2023
 */
export default {
  AddNewVoucherRow: 'AddNewVoucherRow',
  RemoveVoucherRow: 'RemoveVoucherRow',
  CopyVoucherRow: 'CopyVoucherRow',
  ViewAccountBalance: 'ViewAccountBalance',
  ViewRemainingInventory: 'ViewRemainingInventory',
  SaveShapeVoucher: 'SaveShapeVoucher',
  ReloadShapeVoucher: 'ReloadShapeVoucher',
};
